export default {
    en: {
        dashboard: 'Dashboard',
        importArkInvoice: 'Import ark invoice',
        users: 'Users table',
        logs: 'Logs',
        roles: 'Roles',
        user: 'User',
        login: 'Login',
        register: 'Register',
        cashRecords: 'Cash Orders',
        record: 'Cash Order',
        cashReport: 'Cash order report'
    },
    et: {
        dashboard: 'Avaleht',
        importArkInvoice: 'ARK arved',
        users: 'Kasutajate tabel',
        logs: 'Logid',
        roles: 'Rollid',
        user: 'Kasutajad',
        login: 'Sisene',
        register: 'Registreeri',
        cashRecords: 'Kassaraamat',
        record: 'Kassaorder',
        cashReport: 'Kassaraport'
    }
}